/**
 * @file 微信 webview 引导默认浏览器打开
 * @author  yongning.zhao@dji.com 2022-04-01
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SmartIcon from '../SmartIcon';
import Styles from './index.module.scss';

const BrowserViewGuide = ({
  callback,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div
      className={Styles.root}
      onClick={callback}
      role="button"
      tabIndex={0}
      onKeyDown={() => {}}
    >
      <div className={Styles.container}>
        <div className={Styles.description}>点击右上角&quot;···&quot; ，在浏览器中打开</div>
        <SmartIcon className={Styles.bendingArrowGuide} icon="bending-arrow" />
      </div>
    </div>
  );
};

BrowserViewGuide.propTypes = {
  callback: PropTypes.func,
};

BrowserViewGuide.defaultProps = {
  callback: () => {},
};

export default BrowserViewGuide;
